import { render, staticRenderFns } from "./PatternJournal.vue?vue&type=template&id=82681b32&scoped=true"
import script from "./PatternJournal.vue?vue&type=script&lang=js"
export * from "./PatternJournal.vue?vue&type=script&lang=js"
import style0 from "./PatternJournal.vue?vue&type=style&index=0&id=82681b32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82681b32",
  null
  
)

export default component.exports